import { useContext } from 'react'

import { RevenueCatContext } from '@/contexts'

export const useRevenueCat = () => useContext(RevenueCatContext)
